module.exports = __webpack_public_path__ + "img/no-data_filter.a9812301.svg";